















import ripple from "./ripple.vue";
import loadIcon from "./loadIcon.vue";
import { Component, Vue, Prop, Watch} from "vue-property-decorator";

@Component({
    components: {
        ripple,
        loadIcon
    }
})
export default class Button extends Vue {

    @Prop({}) icon:string;
    @Prop({}) rowButton:boolean;
    @Prop({}) text:string;
    @Prop({}) white:boolean;
    @Prop({}) shaded:boolean;
    @Prop({}) coloured:boolean;
    @Prop({}) disabled:boolean;
    @Prop({}) submit:boolean;
    @Prop({}) loading:boolean;
    @Prop({}) toggleState:boolean;
    @Prop({}) unavailable:boolean;
    @Prop({}) small:boolean;
    @Prop({}) noMinimal:boolean;

    isLoading:boolean = false;

    buttonPressed(){
        if(this.loading || this.unavailable || this.disabled) return;
        if(this.submit){
            this.triggerLoad();
        }
        this.$emit("pressed");
    }

    triggerLoad(){
        this.isLoading = true;
    }

    @Watch('loading')
    updateLoading(){
        this.isLoading = this.loading; 
    }
}

